import React from 'react'
import iMg1 from "../../images/ilustraciones soluciones industriales_GOBIERNO 1.png";
import iMg2 from "../../images/ilustraciones soluciones industriales_GOBIERNO 2.png";
import iMg3 from "../../images/gobierno_GOBIERNO 3.png";
import { useLanguage } from '../../Providers/LanguageContext';
import SignUpButton from './SignUpButton';
import AgricultureBanner from './AgricultureBanner';
const Government = () => {
  const { language } = useLanguage();

  return (
    <>
    <AgricultureBanner government={true}/>
      <section id='agriculture_sec'>
        <div className='container-fluid'>
          <div className='row mb-5'>
            <div className='col-md-5 col-12 m-auto agriculture_box'>
              {/* <div className='agriculture_head'>
                <h3 style={{ color: "#000000" }}>{language.government}</h3>
              </div> */}

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000",fontSize:'38px',fontWeight:"700" }}>{language.budget_and_planning}</h4>
                <p style={{
                  color:'#000',
                  fontSize:'20px'
                }}>{language.fisi_help_govt_agency}
                </p>
              </div>

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", textAlign: "right",fontSize:'38px',fontWeight:'700' }}>{language.expense_tracking_reporting}</h4>
                <p style={{
                  color:'#000',
                  fontSize:'20px',
                  textAlign:'right'
                }} >{language.fisi_provide_detail_analytics}</p>
                <p style={{
                  color:'#000',
                  fontSize:'20px',
                  textAlign:'right'
                }}>{language.can_help_Identify}
                </p>
              </div>
            </div>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg1} className='img-fluid' alt='' />
              </div>
            </div>
          </div>

          {/* <div className='row row_reverse mb-5'>

            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", textAlign: "left",fontSize:'38px',fontWeight:'700' }}>{language.expense_tracking_reporting}</h4>
                <p style={{
                  color:'#000',
                  fontSize:'20px'
                }} >{language.fisi_provide_detail_analytics}</p>
                <p style={{
                  color:'#000',
                  fontSize:'20px'
                }}>{language.can_help_Identify}
                </p>
              </div>
            </div>
          </div> */}

          <div className='row mb-5'>
            <div className='col-md-5 col-12 m-auto'>
              <div className='agriculture_img'>
                <img src={iMg2} className='img-fluid' alt='' />
              </div>
            </div>
            <div className='col-md-5 col-12 agriculture_box'>
              <div className='agriculture_headtext '>
                <h4 style={{ color: "#000", textAlign: "right",fontSize:"38px",fontWeight:'700' }}>{language.compliance_and_regulation}</h4>
                <p style={{
                  textAlign:'right',
                  fontSize:'20px',
                  color:'#000'
                }}>{language.govt_agencies_dept}
                </p>
              </div>

              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000", textAlign: "left",fontSize:'38px',fontWeight:'700' }}>{language.transe_and_account}</h4>
                <p style={
                  {
                    color:'#000',
                    fontSize:'20px'
                  }
                }>{language.fisi_help_increase_transparancy}
                </p>
                <p style={{
                  color:'#000',
                  fontSize:'20px'
                }}>{language.build_trust_citigen}
                </p>
              </div>
            </div>
          </div>

          <div className='row wrapBg_Img'>


            {/* <div className='col-md-12 col-12 m-auto'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000000", textAlign: "left" }}>{language.transe_and_account}</h4>
                <p>{language.fisi_help_increase_transparancy}
                </p>
                <p>{language.build_trust_citigen}
                </p>
              </div>
            </div> */}


            <div className='col-md-6 col-12 m-auto pt-5 agriculture_box' >
              <div className='agriculture_headtext'>
                <h4 style={{ color:'#000',fontSize:'38px',fontWeight:'700' }}>{language.grant_management}</h4>
                <p style={{
                  color:'#000',
                  fontSize:'20px'
                }}>{language.many_govt_agencies_dept}
                </p>
              </div>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000000", fontSize:'38px',fontWeight:'700' }}>{language.auditing_supplier_invoices}</h4>
                <p style={{
                  color:'#000',
                  fontSize:'20px'
                }}>{language.fisi_help_save_money}
                </p>

              </div>
            </div>

            <div className='col-md-5 col-12 m-auto mb-5'>
              <div className='agriculture_img' style={{ maxWidth: "100%", }}>
                <img src={iMg3} className='img-fluid' alt='' style={{ marginBottom: "30px" }} />

                {/* <div className='registrarAnddescargar' style={{ transform: "translate(-50% , -50%)", top: "100%", }}>
                  <button className='registrar_Btn' style={{ background: "#000" }}>Registrarse</button>
                  <button className='descargar_Btn'>Descargar</button>
                </div> */}
                <SignUpButton/>
              </div>
            </div>
            {/* <div className='col-md-12 col-12 m-auto'>
              <div className='agriculture_headtext'>
                <h4 style={{ color: "#000000", textAlign: "right" }}>{language.auditing_supplier_invoices}</h4>
                <p>{language.fisi_help_save_money}
                </p>

              </div>
            </div> */}
          </div>
        </div>
      </section>

    </>
  )
}

export default Government